export default "__VITE_ASSET__BCBtxZYi__"